import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  // Portfolio items data
  const portfolioItems = [
    {
      id: 1,
      title: "E-Commerce Brand Launch",
      category: "Digital Advertising",
      image: "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80",
      description: "360° digital campaign for a fashion e-commerce startup resulting in 300% revenue growth in first quarter.",
      tags: ["Social Media", "PPC", "Influencers"],
      link: "/portfolio/ecommerce-case-study"
    },
    {
      id: 2,
      title: "Tech Conference Promotion",
      category: "Event Marketing",
      image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1712&q=80",
      description: "Sold-out tech conference with 2000+ attendees through targeted digital campaigns.",
      tags: ["Email Marketing", "LinkedIn Ads", "Webinars"],
      link: "/portfolio/tech-conference"
    },
    {
      id: 3,
      title: "Healthcare Brand Awareness",
      category: "Content Marketing",
      image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
      description: "Increased brand visibility by 150% for healthcare provider through educational content series.",
      tags: ["SEO", "Blog Content", "Video"],
      link: "/portfolio/healthcare-campaign"
    },
    {
      id: 4,
      title: "Food Product Launch",
      category: "Influencer Marketing",
      image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1760&q=80",
      description: "Successful nationwide launch reaching 5M+ consumers through micro-influencer network.",
      tags: ["Instagram", "Recipe Content", "UGC"],
      link: "/portfolio/food-product-launch"
    },
    {
      id: 5,
      title: "B2B SaaS Lead Generation",
      category: "Performance Marketing",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      description: "Generated 500+ qualified leads for enterprise software solution.",
      tags: ["LinkedIn Ads", "Retargeting", "Case Studies"],
      link: "/portfolio/saas-campaign"
    },
    {
      id: 6,
      title: "Nonprofit Fundraising",
      category: "Social Media Campaign",
      image: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
      description: "Raised $250,000 through viral social media challenge campaign.",
      tags: ["Facebook", "User Stories", "Community Building"],
      link: "/portfolio/nonprofit-fundraising"
    }
  ];

  // Categories for filtering
  const categories = ["All", "Digital Advertising", "Content Marketing", "Influencer Marketing", "Performance Marketing", "Event Marketing", "Social Media Campaign"];
  
  // State for active filter
  const [activeFilter, setActiveFilter] = useState("All");

  // Filter function
  const filteredItems = activeFilter === "All" 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeFilter);

  return (
    <section className="portfolio-page py-5">
      <div className="container">
        {/* Hero Header */}
        <div className="row mb-5">
          <div className="col-lg-10 mx-auto text-center">
            <h1 className="display-4 fw-bold mb-3">Our Portfolio</h1>
            <p className="lead text-muted">
              Explore our successful campaigns that delivered measurable results for clients across industries.
            </p>
          </div>
        </div>

        {/* Filter Controls */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="d-flex flex-wrap justify-content-center gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`btn ${activeFilter === category ? 'btn-primary' : 'btn-outline-primary'} rounded-pill px-4`}
                  onClick={() => setActiveFilter(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="row g-4">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6">
                <div className="portfolio-card card h-100 border-0 shadow-sm overflow-hidden">
                  <div className="portfolio-image">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="img-fluid w-100"
                    />
                    {/* <div className="portfolio-overlay">
                      <Link to={item.link} className="btn btn-light btn-sm">
                        View Case Study
                      </Link>
                    </div> */}
                  </div>
                  <div className="card-body">
                    <span className="badge bg-primary mb-2">{item.category}</span>
                    <h3 className="h5">{item.title}</h3>
                    <p className="text-muted">{item.description}</p>
                    <div className="d-flex flex-wrap gap-2 mt-3">
                      {item.tags.map((tag) => (
                        <span key={tag} className="badge bg-light text-dark">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <h3>No projects found in this category</h3>
              <button 
                className="btn btn-link"
                onClick={() => setActiveFilter("All")}
              >
                Show all projects
              </button>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto text-center py-5 bg-light rounded-3">
            <h2 className="mb-4">Ready to See Similar Results for Your Business?</h2>
            <Link to="/contact" className="btn btn-primary btn-lg px-5">
              Get Started Today
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;